import axios from 'axios'
import {
  SET_VARIANT,
  CHANGE_VARIANT_INVENTORY
} from '@/store/mutation-types'

const setVariant = ({commit, dispatch}, data) => {
  commit(SET_VARIANT, data)
}
const changeVariantInventory = ({commit, dispatch}, data) => {
  commit(CHANGE_VARIANT_INVENTORY, data)
}

const checkVariantInventory = async function ({commit, dispatch}, {variantId, quantity}) {
  console.log('checkVariantInventory', variantId)
  let response = await axios.get(`${process.env.ECOMMERCE_URL}/products/variants/${variantId}/check?include=product`)
  if (response && response.data) {
    console.log('response.data.inventory', response.data.inventory, quantity)
    // this.setVariant(response.data)
    commit(SET_VARIANT, response.data)
    if (response.data.inventory >= quantity) return true
  }
  return false
}

export default {
  setVariant,
  changeVariantInventory,
  checkVariantInventory
}



// WEBPACK FOOTER //
// ./src/components/preview/store/actions.js